import {
    httpGetProjectSocialWelfareConditions,
    HttpGetProjectSocialWelfareConditionsResponse
} from '@/features/projects/http/projects.http'
import {QUERY_KEYS} from '@/queryClient'
import {ErrorResponseData} from '@/types'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

interface UseGetProjectSocialWelfareConditionsOptions {
    urlParams: {
        projectId: string
    }
    options?: Omit<
        UseQueryOptions<HttpGetProjectSocialWelfareConditionsResponse, AxiosError<ErrorResponseData>>,
        'queryKey' | 'queryFn'
    >
}

export const useGetProjectSocialWelfareConditions = ({
    urlParams,
    options
}: UseGetProjectSocialWelfareConditionsOptions) =>
    useQuery({
        queryKey: [QUERY_KEYS.PROJECT_SOCIAL_WELFARE_CONDITIONS, urlParams.projectId],
        queryFn: () => httpGetProjectSocialWelfareConditions({urlParams}),
        ...options
    })
